import { createSlice } from "@reduxjs/toolkit";
import { errorHandler } from "../../../helpers/errorHandler";
import { Call } from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";

const initialState = {
    validateRequirements: null,
};

export const GraduationOptionsRequirements = createSlice({
    name: "GraduationOptionsRequirements",
    initialState,
    reducers: {
        setValidateRequirements: (state, action) => {
            state.validateRequirements = action.payload;
        },
        clearValidateRequirements: (state) => {
            state.validateRequirements = initialState.validateRequirements;
        },
    },
});

export const { setValidateRequirements, clearValidateRequirements } =
    GraduationOptionsRequirements.actions;

export default GraduationOptionsRequirements.reducer;

//* Actions
export const startGetValidateRequirements = ({
    academic_record_id,
    option,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("academic_record_id", academic_record_id);
        params.set("option", option);

        const resp = await Call(
            `operators/graduation/validate/requirements`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setValidateRequirements(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};
